<template>
  <el-row>
    <!-- 标签 --> 
    <el-row style="width:70%; margin:0 auto; ">
      <el-menu
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b">
        <el-menu-item index="/Index">缴费页</el-menu-item>
        <el-menu-item index="/Exit">退出</el-menu-item>
      </el-menu>
      <!-- 通知 -->
      <div class="notice" v-if="tipText !== ''">
        <van-notice-bar left-icon="volume-o" :text=tipText />
      </div>
      <div v-show="mainVisible">
        <div class="content-main">
          <div class="content-tital">公寓用品选择</div>
          <el-checkbox-group class="content-group" v-model="dormConfigCheckList">
            <template v-for="item in dormConfigList">
              <el-checkbox class="content-group-item" :disabled="item.field1 === '01'" :key="item.modeId" :label="item.modeId">
                <div>
                  <div>{{ item.modeName }}</div>
                  <div style="color: #e6a23c;font-size: 12px;">{{ '价格：' + Ginkgo.format(item.modeValue, 'money') }}</div>
                </div>
              </el-checkbox>
              <el-divider class="content-divider" :key="item.modeId"/>
            </template>
          </el-checkbox-group>
          <div class="content-refund">
            <div>{{ '退费金额:' + Ginkgo.format(refundMoney, 'money') }}</div>
          </div>
          <div v-if="false">
            <!-- <div v-if="Number(refundMoney) > 0"> -->
            <div class="content-tital">退款银行卡信息</div>
            <el-row v-if="cardInfo.length === 0" style="height:60px;text-align:center;margin-top:30px;">
              <span style="font-size:15px;">银行卡信息为空，请先去维护银行卡信息！</span>
            </el-row>
            <el-form v-else style="padding: 10px;" ref="form" :model="form" label-width="80px" size="mini">
              <el-form-item label="账户名">
                <el-input disabled="true" v-model="form.acnm"></el-input>
              </el-form-item>
              <el-form-item label="账户号">
                <el-input disabled="true" v-model="form.acno"></el-input>
              </el-form-item>
              <el-form-item label="开户行">
                <el-input disabled="true" v-model="form.bankNm"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <el-row style="width:100%;margin: 20px auto">
          <el-button style="width: 100%" type="success" @click="submit()">提 交</el-button>
        </el-row>
      </div>
      <div v-show="tipVisible">
        <div class="content-main">
          <div class="content-tital">公寓用品领用项
            <el-tag class="style-tag" v-if="isClaim === '00'" type="success">已完成</el-tag>
            <el-tag class="style-tag" v-else-if="isClaim === '01'" type="primary">待确认</el-tag>
            <el-tag class="style-tag" v-else type="warning">待领取</el-tag>
          </div>
          <div style="padding: 1rem 0 0 0;">
            <table style="color: rgb(9, 9, 9);text-align: center;border-collapse:collapse;width: 95%;margin: auto;" border="1">
              <tr style="line-height: 4vh;font-size: 1rem;font-weight: 500;background: #409eff;">
                <td style="width: 50%;">项目</td>
                <td>收费标准(元)</td>
                <td>是否领取</td>
              </tr>
              <tr v-for="(item, index) in claimApplyList" :key="index">
                <td>{{ item.supplyId }}</td>
                <td>{{ Ginkgo.format(item.feeAmount, 'money') }}</td>
                <td>{{ (item.applyStatus === '00') ? '是' : '否' }}</td>
              </tr>
              <tr style="background: #f8e0bd;">
                <td style="width: 50%;">退款金额</td>
                <td>{{Ginkgo.format(refundMoney, 'money')}}</td>
                <td></td>
              </tr>
            </table>
          </div>
          <div v-if="isClaim === '01' && isApplyTime" style="display: flex;justify-content: space-between;padding: 15px 10px;">
            <el-button style="width: 46%;" type="primary" size="mini" @click="update()">重新提交</el-button>
            <el-button style="width: 46%;" type="success" size="mini" @click="toPrint()">打印领用单</el-button>
          </div>
        </div>
      </div>
      <div ref="printContent" v-show="printVisible">
        <div v-if="claimApplyList.length > 0" class="content">
          <el-row style="background-color: #fff;padding: 10px;border-radius: 5px;font-size: 3vw;">
            <h1 style="color: rgb(9, 9, 9);text-align: center;font-size: 4.5vw;padding: 0 0 1vh 0;">西安翻译学院新生入学公寓用品领用单</h1>
            <div style="display: flex;justify-content: space-between;">
              <div style="width: 85%;">
                <div style="padding: 5px 0 0 0;">姓名：{{ curStudent.studentName }}</div>
                <div style="padding: 5px 0 0 0;">性别：{{ curStudent.sex }}</div>
                <div style="padding: 5px 0 0 0;">学号：{{ curStudent.studentNo }}</div>
                <div style="padding: 5px 0 0 0;">领用点：{{ claimApplyList[0].dealName }}</div>
                <div style="padding: 5px 0 0 0;">公寓：{{ dormRow.flatsName }}</div>
                <div style="padding: 5px 0 0 0;">宿舍：{{ dormRow.roomNo }} 号 {{dormRow.bedNo}} 床位</div>
                <div style="padding: 5px 0 0 0;">申请日期：{{ Ginkgo.format(claimApplyList[0].applyTm, 'time') }}</div>
                <div style="padding: 5px 0 0 0;">缴费订单号：{{ dormOrderInfo.orderNo }}</div>
                <div style="padding: 5px 0 0 0;">缴费日期：{{ Ginkgo.format(dormOrderInfo.transDt + String(dormOrderInfo.transTm).padStart(6, '0'), 'time') }}</div>
              </div>
              <div style="width: 15%;">
                <vue-qr style="width: 100%;" :logoSrc="imageUrl" :text="curStudent.studentNo" :size="200"></vue-qr>
              </div>
            </div>
            <div style="display: flex;flex-wrap: wrap;">
              <div style="padding: 3px 0 0 0;width: 50%;">交费金额：{{ Ginkgo.format(dormOrderInfo.feeAmount, 'money') }}</div>
              <div style="padding: 3px 0 0 0;width: 50%;">退费金额：{{ Ginkgo.format(refundMoney, 'money') }}</div>
            </div>
            <div style="padding: 15px 0;">
              <table style="color: rgb(9, 9, 9);text-align: center;border-collapse:collapse;font-size:3vw;width: 100%" border="1">
                <tr>
                  <td style="width: 50%;">项目</td>
                  <td>收费标准(元)</td>
                  <td>是否领取</td>
                </tr>
                <tr v-for="(item, index) in claimApplyList" :key="index">
                  <td>{{ item.supplyId }}</td>
                  <td>{{ Ginkgo.format(item.feeAmount, 'money') }}</td>
                  <td>{{ (item.applyStatus === '00') ? '是' : '否' }}</td>
                </tr>
              </table>
            </div>
          </el-row>
        </div>
      </div>
    </el-row>
  </el-row>
</template>
<script>
import Decimal from 'decimal.js'
import vueQr from 'vue-qr'
import vanNoticeBar from 'vant/lib/notice-bar'
import 'vant/lib/notice-bar/style'

export default {
  name: 'receive',
  components: { vueQr, vanNoticeBar },
  data: function () {
    return {
      curStudent: [],
      mainVisible: false,
      tipVisible: false,
      printVisible: false,

      tipText: '',
      dormOrderInfo: {},
      dormModeSelectList: {}, // 选中的数据字典
      claimApplyList: [], // 已经提交的领用单

      modeSelectList: [],
      dormConfigList: [], // 公寓用品字典
      dormConfigCheckList: [], // 公寓用品已选择
      checkMoney: 0,
      refundMoney: 0,

      cardInfo: [],
      form: {
        id: '',
        acnm: '',
        acno: '',
        bankNm: ''
      },
      dormRow: {}, // 床位信息
      isClaim: '', // 领用状态
      isApplyTime: false // 是否在领用期
    }
  },
  mounted: function () {
    var self = this
    if (process.env.NODE_ENV === 'production') {
      this.curStudent = this.global.curStudent
      this.getMode()
      this.isApplyTime = this.getIsApplyTime()
      // 判断是否在公寓用品领用时间
      if (!this.isApplyTime) {
        // 不在领用期直接查领用历史
        this.getClaimApply()
      } else {
        // 校验学生是否已经缴费
        this.axios.all([this.getStudentCard(), this.validOrderInfo()]
        ).then(this.axios.spread(function (card, order) {
          if (card.data.result.success === true) {
            self.cardInfo = card.data.dataList
            if (self.cardInfo.length > 0) {
              self.form = self.cardInfo[0]
            }
          }
          if (order.data.result.success === true) {
            if (order.data.orderInfoList.length > 0) { // 有缴费记录
              self.dormOrderInfo = order.data.orderInfoList.filter(item => item.feeNo === '宿舍用品费')[0]
              self.getClaimApply()
            } else {
              // 提醒没缴费，先去缴费
              self.$confirm('您还未缴费，是否进行缴费!', '提示', {
                confirmButtonText: '确定'
              }).then(() => {
                self.$router.push('/myBillXiFanNew')
                self.route = [{ path: '/myBillXiFanNew', component: require('@/components/XiFan/MyBillXiFanNew'), meta: { title: '新生缴费页面' } }]
                self.$router.addRoutes(self.route)
              }).catch(() => {
                self.$router.go(-1)
              })
            }
          } else {
            self.$alert('系统错误！' + order.data.result.msg)
          }
        }))
      }
    }
  },
  watch: {
    tabSelected: 'handleSelect',
    'dormConfigCheckList': 'handleCheck'
  },
  methods: {
    // 判断是否在公寓用品领用时间
    getIsApplyTime: function () {
      var self = this
      let receiveInfo = self.modeSelector('CM_Block_Receive_Time').filter(item => item.modeValue.substring(0, 4) === self.curStudent.enrollmentYear.toString())
      if (receiveInfo.length > 0) {
        self.tipText = receiveInfo[0].field4
        let newDate = self.Ginkgo.dateToInt(new Date())
        if (newDate >= receiveInfo[0].field2 && newDate <= receiveInfo[0].field3) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    handleSelect: function (index, indexPath) {
      if (index === '/Exit') {
        this.$router.push('/LoginXiFan')
      } else if (index === '/Index') {
        this.$router.go(-1)
      }
    },
    // 查是否维护银行卡信息
    getStudentCard: function () {
      // var self = this
      let obj = {}
      obj.studentName = this.global.curStudent.studentName
      obj.studentNo = this.global.curStudent.studentNo
      return this.axios.post('/college/getStudentCard', obj)
    },
    validOrderInfo: function () {
      return this.axios.post('/college/getXFOrderInfoForCheck', {
        field1: this.global.curStudent.studentName,
        keyInfo: this.global.curStudent.uid,
        field12: '04',
        statusCode: '00'
      })
    },
    // 查领用单
    getClaimApply: function () {
      var self = this
      let obj = {}
      obj.studentName = this.global.curStudent.studentName
      obj.studentNo = this.global.curStudent.studentNo
      this.axios.post('/college/getClaim', obj)
      .then(function (response) {
        if (response.data.result.success === true) {
          self.claimApplyList = response.data.dataList
          // 计算退费
          self.refundMoney = 0
          self.claimApplyList.forEach(item => {
            if (item.applyStatus === '01') {
              self.refundMoney = Decimal(self.refundMoney).plus(Decimal(item.feeAmount)).toString()
            }
          })
          // 判断是否在领用期
          if (self.isApplyTime) {
            if (self.claimApplyList.length > 0) {
              self.isClaim = self.claimApplyList[0].isClaim
              self.setVisible('01')
            } else {
              // 默认全选
              self.dormConfigList.forEach(element => {
                self.dormConfigCheckList.push(element.modeId)
              })
              // 显示公寓用品领取页面
              self.setVisible('00')
            }
          } else {
            if (self.claimApplyList.length > 0) {
              self.isClaim = self.claimApplyList[0].isClaim
            }
            self.setVisible('01')
          }
        } else {
          self.$alert('领用单查询错误！' + response.data.result.msg)
        }
      })
    },
    // 初始化数据字典
    getMode: function () {
      var self = this
      self.modeSelectList = self.global.modeList
      // 初始化公寓用品
      self.dormConfigList = self.modeSelectList.filter(item => { return item.typeId === 'Apart_Supply_Kind' })
      // 默认全选
      self.dormConfigList.forEach(element => {
        self.dormConfigCheckList.push(element.modeId)
      })
    },
    handleCheck: function (val) {
      if (this.dormOrderInfo.feeAmount) {
        this.checkMoney = 0
        this.refundMoney = 0
        this.dormModeSelectList = this.dormConfigList.filter(item1 =>
          val.some(item2 => item2 === item1.modeId)
        )
        this.dormModeSelectList.forEach(item => {
          this.checkMoney = Decimal(this.checkMoney).plus(Decimal(item.modeValue)).toString()
        })
        this.refundMoney = Decimal(this.dormOrderInfo.feeAmount).minus(Decimal(this.checkMoney)).toString()
      }
    },
    submit: function () {
      // if (this.form.acno === '') {
      //   this.$confirm('银行卡信息为空，是否去维护银行卡信息!', '提示', {
      //     confirmButtonText: '确定'
      //   }).then(() => {
      //     this.$router.push('/card')
      //     this.route = [{ path: '/card', component: require('@/components/XiFan/NewStudent/card'), meta: { title: '银行卡信息维护页面' } }]
      //     this.$router.addRoutes(this.route)
      //   })
      // } else {
      //   this.doSubmit()
      // }
      this.doSubmit()
    },
    // 领取提交
    doSubmit: function () {
      var self = this
      let saveList = []
      this.dormConfigList.forEach(item => {
        let obj = {}
        obj.studentName = this.global.curStudent.studentName
        obj.studentNo = this.global.curStudent.studentNo
        obj.applyTm = this.Ginkgo.getTimeStamp(new Date())
        obj.supplyId = item.modeId
        obj.isClaim = '01'
        obj.dormNumber = this.dormOrderInfo.field13
        obj.orderNo = this.dormOrderInfo.orderNo
        // 判断是否领用
        if (this.dormConfigCheckList.includes(item.modeId)) {
          obj.applyStatus = '00'
        } else {
          obj.applyStatus = '01'
        }
        obj.cardId = this.form.id
        saveList.push(obj)
      })
      this.axios.post('/college/saveClaimAll', saveList)
      .then(function (response) {
        if (response.data.result.success === true) {
          self.getClaimApply()
        } else {
          self.$alert('提交失败！' + response.data.result.msg)
        }
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    update: function () {
      this.dormConfigCheckList = []
      this.claimApplyList.forEach(item => {
        if (item.applyStatus === '00') {
          this.dormConfigCheckList.push(item.supplyId)
        }
      })
      this.setVisible('00')
    },
    toPrint: function () {
      var self = this
      self.axios.all([self.getDormList()])
      .then(self.axios.spread(function (dorm) {
        if (dorm.data.result.success === true) {
          self.dormRow = dorm.data.viXFDormOneList[0]
          // 计算退费
          self.refundMoney = 0
          self.claimApplyList.forEach(item => {
            if (item.applyStatus === '01') {
              self.refundMoney = Decimal(self.refundMoney).plus(Decimal(item.feeAmount)).toString()
            }
          })
          self.doPrint()
        }
      }))
    },
    doPrint: function () {
      var self = this
      let codestr = ''
      self.$nextTick(() => {
        codestr = this.$refs.printContent.innerHTML
      })
      this.$confirm('确定要打印学号为' + this.curStudent.studentNo + '，姓名为' + this.curStudent.studentName + '的公寓用品领用单吗?(请使用谷歌浏览器打印)', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        let newWindow = window.open('_blank') // 打开新窗口
        // 向文档写入HTML表达式或者JavaScript代码
        newWindow.document.write(codestr)
        newWindow.document.close() // 关闭document的输出流, 显示选定的数据
        newWindow.print() // 打印当前窗口
        setTimeout(newWindow.close(), 0)
        self.termMsg = '打印完成！'
        return true
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    // 获取学生所选床位
    getDormList: function () {
      var self = this
      return self.axios.get('/college/getViXFDorm', { params: {
        bedId: self.dormOrderInfo.field13
      }})
    },
    setVisible: function (showType) {
      if (showType === '00') {
        // 首页
        this.mainVisible = true
        this.tipVisible = false
      } else if (showType === '01') {
        // 提示页
        this.mainVisible = false
        this.tipVisible = true
      } else if (showType === '02') {
        // 打印页
        this.tipVisible = false
        this.printVisible = true
      }
    },
    // 数据字典筛选器
    modeSelector: function (typeId) {
      return this.modeSelectList.filter(function (element) {
        return element.typeId === typeId
      })
    }
  }
}
</script>
<style scoped>
.content-main {
  background-color: #fff;
  border-radius: 5px;
}
.mint-checklist-title {
  font-size: 1rem;
}
.content-tital {
  font-size: 1rem;
  padding: 5px 10px;
  font-weight: 500;
  color: #909399;
  background-color: aliceblue;
}
.content-group {
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.content-refund {
  padding: 10px;
  color: red;
  font-weight: 600;
  font-size: 1rem;
}
.content-group-item {
  display: flex;
  align-items: center;
}
.el-divider {
  margin: 8px 0 !important;
}
.el-checkbox {
  white-space: normal;
  margin-right: 0;
}
.el-input {
  width: 100%;
}
.print-div {
  width: 50%;
  padding: 3px 0 0 0;
}
</style>


// WEBPACK FOOTER //
// receive.vue?5ce48938